import { Stack } from "@mui/material";
import CSVLink from "components/CSVLink";
import { Table } from "components/Table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import type { EnergyAnalysisYearlyTableRow } from "../model/types";

import { buildEnergyAnalysisDownloadRows, buildEnergyAnalysisTableHeaders } from "../lib/tableConfig";
import { EnergyAnalysisSectionTitle } from "./EnergyAnalysisSectionTitle";

type EnergyAnalysisDataTableProps = {
  categoryKeys: string[];
  firstColumnLabel: string;
  rows: EnergyAnalysisYearlyTableRow[];
  valueLabel: string;
};

export const EnergyAnalysisDataTable = ({
  categoryKeys,
  firstColumnLabel,
  rows,
  valueLabel,
}: EnergyAnalysisDataTableProps) => {
  const { t } = useTranslation();
  const headers = useMemo(
    () => buildEnergyAnalysisTableHeaders(categoryKeys, valueLabel, firstColumnLabel),
    [categoryKeys, firstColumnLabel, valueLabel]
  );
  const downloadRows = useMemo(
    () => buildEnergyAnalysisDownloadRows(rows, categoryKeys, valueLabel, firstColumnLabel),
    [categoryKeys, firstColumnLabel, rows, valueLabel]
  );
  return (
    <Stack className="w-full flex-col items-stretch gap-3">
      <Stack className="w-full justify-between">
        <EnergyAnalysisSectionTitle iconName="ListIcon" title={t("BuildingProfile.energyAnalysis.tableTitle")} />
        <CSVLink color="var(--color-element-primary-initial)" data={downloadRows} />
      </Stack>
      <Table className="max-h-[40rem]" data={rows} headers={headers} idColumnName="id" />
    </Stack>
  );
};
